/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'round-arrow-folder/line-m': {
    width: 40,
    height: 40,
    viewBox: '0 0 40 40',
    data: '<path pid="0" d="M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm0 1C9.507 1 1 9.507 1 20s8.507 19 19 19 19-8.507 19-19S30.493 1 20 1zm-.217 13.04a.508.508 0 01.155.03l.028.01c.024.01.047.024.07.038l.013.008c.025.017.05.036.072.059l5.69 5.69.065.078a.5.5 0 01-.693.694l-.078-.065-4.837-4.837V25.92a.5.5 0 01-1 0V15.745l-4.837 4.837a.5.5 0 01-.707-.707l5.69-5.69.078-.065a.5.5 0 01.08-.042l.011-.004a.5.5 0 01.077-.023l.026-.004a.508.508 0 01.068-.007l.014-.002.015.002z" _fill="#0077C8"/>'
  }
})
